import { createSlice } from "@reduxjs/toolkit";
import { PackageUnitResponseDto } from "../../shared/dtos/packageUnit/PackageUnitResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const packageUnitSlice = createSlice({
  name: "packageUnit",
  initialState: getInitialCrudState<PackageUnitResponseDto>(),
  reducers: {
    ...generateCrudReducers<PackageUnitResponseDto>(),
  },
});

export const packageUnitActions = packageUnitSlice.actions;
export default packageUnitSlice.reducer;
